module.exports = __webpack_public_path__ + "static/media/morakot-bg1.b08dbad1.png";